(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let manuallyPaused = false;
  function sync() {
    const paused = manuallyPaused || preference.matches;
    document.documentElement.classList.toggle('nph-motion-paused', paused);
    document.querySelectorAll('[data-home-motion-toggle]').forEach(button => {
      button.setAttribute('aria-pressed', String(paused));
      button.textContent = paused ? button.dataset.play : button.dataset.pause;
    });
  }
  function init(root) {
    if (root.dataset.motionInitialized || root.dataset.homeMotion !== 'true') return;
    root.dataset.motionInitialized = 'true';
    const scene = root.querySelector('.nph-hero__scene');
    root.querySelector('[data-home-motion-toggle]')?.addEventListener('click', () => {
      manuallyPaused = !manuallyPaused;
      sync();
    });
    if ('IntersectionObserver' in window) {
      if (scene) new IntersectionObserver(entries => {
        scene.classList.toggle('nph-motion-offscreen', !entries[0].isIntersecting);
      }).observe(scene);
      if (!preference.matches) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('nph-visible');
              observer.unobserve(entry.target);
            }
          });
        }, {threshold:.04});
        root.querySelectorAll('.nph-category-grid>li,.nph-product-grid>li,.nph-story,.nph-more-card').forEach((item,index) => {
          item.style.setProperty('--nph-reveal-delay', (index % 6) * 45 + 'ms');
          item.classList.add('nph-reveal');
          observer.observe(item);
        });
      }
    }
    root.classList.add('nph-animation-enabled');
    sync();
  }
  function initAll() {document.querySelectorAll('.nph[data-home-motion]').forEach(init);}
  preference.addEventListener('change', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initAll,{once:true});
  else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
